import { useState } from "react";
import type { EpisodeGuide as EpisodeGuideType } from "@/types";

export default function EpisodeGuide({ guides }: { guides: EpisodeGuideType[] }) {
  const [active, setActive] = useState(0);

  return (
    <section className="bg-background-50 rounded-lg border border-background-200 p-4 md:p-6">
      <div className="flex items-center gap-3 mb-5">
        <span className="w-1.5 h-6 rounded-full bg-secondary-500" />
        <h2 className="font-heading text-xl font-bold text-foreground-950">
          分集剧情解析
        </h2>
        <span className="text-xs text-foreground-400 ml-auto">
          演示内容 · 共 {guides.length} 集解析
        </span>
      </div>

      <div className="flex flex-wrap gap-2 mb-5">
        {guides.map((g, i) => (
          <button
            key={g.episode}
            type="button"
            onClick={() => setActive(i)}
            className={`px-3.5 py-1.5 rounded-md text-sm cursor-pointer transition-colors ${
              i === active
                ? "bg-secondary-500 text-background-50 font-medium"
                : "bg-background-100 text-foreground-600 hover:bg-background-200"
            }`}
          >
            第 {g.episode} 集
          </button>
        ))}
      </div>

      <div className="rounded-lg bg-background-100 border border-background-200 p-4 md:p-5">
        <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2">
          第 {guides[active].episode} 集 · {guides[active].title}
        </h3>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
          {guides[active].content}
        </p>
      </div>
    </section>
  );
}